;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "FbvtMUXqYe"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
  var _this = jQuery(this),
      list  = _this.find('.lh-blog-list'),
      count = _this.find('.lh-count-art');
  var blog_handle = _this.find('.lh-blog-section').data('blogHandle');
  if(blog_handle.length)
    setActiveCate(_this.find('.lh-item-title a[data-value^="'+blog_handle+'"]').eq(0));
  else
    setActiveCate(_this.find('.lh-item-title.active a'));
  _this.find('.lh-item-title a').click(function(){
    var __this = $(this);
    if(!__this.hasClass('active')){
      setActiveCate(__this);
    }

  })
  function setActiveCate($this) {
    $this.parent().addClass('active').siblings('.active').removeClass('active');
    var target = $this.data('value'),
        e_target = _this.find('.lh-item-blog[data-handle="'+target+'"]');
    if(e_target){
      list.css('transform','translateX(-'+(e_target.index()*100)+'%)');
      e_target.addClass('active').siblings('.active').removeClass('active')
      count.text(e_target.data('count'));
    }
  }
 };						cb.bind($('section[data-section-id="FbvtMUXqYe"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="FbvtMUXqYe"]').get(0))({						url: "https://library.layouthub.com/HUB/files/Tm92LS0yMDE5/NTc0ODY0ODc5/First_release/pages/Ozzy_Blog/blog/",						settings: {}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');